import * as React from 'react';

import { Body, Container, Title } from '@/components/post-form';
import { PostSettings } from '@/components/post-form/PostSettings';

import { PollOptions } from './components/PollOptions';

export const PollForm: React.FC<{
  organizationId?: string;
  initialGroupId?: string;
  isEditing?: boolean;
  isPublished?: boolean;
}> = (props) => {
  const validationMessage = 'A poll requires a title or description.';

  return (
    <Container>
      <Title
        formLabel="Poll Title"
        placeholder="What is your poll about?"
        validationMessage={validationMessage}
      />
      <Body
        formLabel="Description"
        placeholder="Write a description for your poll"
        validationMessage={validationMessage}
      />

      <PollOptions />

      <PostSettings
        isEditing={!!props.isEditing}
        isPublished={!!props.isPublished}
        initialGroupId={props.initialGroupId}
        organizationId={props.organizationId}
      />
    </Container>
  );
};
